import { BatchSkiptraceRepoLive } from 'features/BatchSkiptrace/infra/repo/BatchSkiptraceRepoLive'
import { BatchSkiptraceStore } from 'features/BatchSkiptrace/infra/views/BatchSkiptraceStore'

export const useBatchSkiptraceStore = BatchSkiptraceStore.make({
  batchSkiptraceRepo: BatchSkiptraceRepoLive,
})
